import { Swiper } from 'swiper';
import {
  Navigation,
  Pagination,
  EffectCreative,
  Autoplay,
  Thumbs,
} from 'swiper/modules';
import { A11y } from './modules/a11y/a11y.mjs';

export const addPageheaderSlider = () => {
  const swiperThumbInstance = new Swiper('.slider__pageheader-thumb', {
    modules: [EffectCreative, Autoplay],
    pagination: false,
    navigation: false,
    loop: false,
    speed: 1200,
    effect: 'creative',
    creativeEffect: {
      limitProgress: 2,
      prev: {
        opacity: 0,
      },
      next: {
        opacity: 0,
      },
    },
    watchSlidesProgress: true,
    A11y: true,
  });

 const swiperPageheadInstance = new Swiper('.slider--pageheader', { // eslint-disable-line
    modules: [Navigation, Pagination, A11y, EffectCreative, Autoplay, Thumbs],
    pagination: {
      type: 'bullets',
      el: '.slider__pagination',
      clickable: true,
    },
    grabCursor: true,
    resistanceRatio: 0.1,
    touchEventsTarget: 'swiper-slide',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1200,
    loop: true,
    effect: 'creative',
    creativeEffect: {
      limitProgress: 2,
      prev: {
        translate: ['-100%', 0, 0],
      },
      next: {
        translate: ['100%', 0, 0],
      },
    },
    thumbs: {
      swiper: swiperThumbInstance,
    },
  });

  const addPageheaderInstances = {
    thumbSlider: swiperThumbInstance,
    mainPageheaderSlider: swiperPageheadInstance,
  };

  return addPageheaderInstances;
};
